<template>
  <div>
    <input
      @change="cropper"
      ref="inputfile"
      type="file"
      name="file-1[]"
      id="file-1"
      class="inputfile inputfile-1"
      data-multiple-caption="{count} files selected"
      multiple
      accept="image/*"
    />

    <!-- Area clicável para upload -->
    <div @click.prevent="change()">
      <slot
        class="btn_2 btn_md btn-primary-out mr_10"
        style="min-width: 150px"
        for="file-1"
      ></slot>
    </div>

    <drawer
      :title="'Ajuste sua imagem'"
      :open="openDrawer"
      :close="closeDrawer"
      :closeValidation="confirmClose"
      :zIndex="1100"
    >
      <base-steps ref="uploadImage" :hideButtons="true">
        <div>
          <div v-if="this.errors.length > 0" class="text-center mb_15">
            <base-message
              v-for="(error, i) in this.errors"
              :key="i"
              class="mb_15"
              design="red"
            >
              <span>{{ error }}</span>
            </base-message>
          </div>
          <div v-if="this.warnings.length > 0" class="text-center mb_15">
            <base-message
              v-for="(warning, i) in this.warnings"
              :key="i"
              class="mb_15"
              design="gold"
            >
              <span>{{ warning }}</span>
            </base-message>
          </div>
          <div class="cropper-box cropper-bg">
            <cropper
              :zIndex="1100"
              ref="cropperPreview"
              :src="img"
              :stencil-props="{ aspectRatio: ratio }"
              :minWidth="minCropWidth"
              :minHeight="minCropHeight"
              :stencilComponent="
                circle
                  ? $options.components.CircleStencil
                  : $options.components.RectangleStencil
              "
              @change="checkLimits"
            />
          </div>
          <!-- <div class="text-center">
          <base-button
            class="btn_2 btn-primary btn_md mt_15"
            :disabled="btnCrop"
            @click.prevent="crop"
          >Cortar</base-button>
        </div> -->
        </div>

        <div>
          <img
            class="w-100"
            :src="previewImage"
            alt=""
            :class="circle ? 'circle' : ''"
          />
        </div>
      </base-steps>
      <template slot="footer">
        <div class="d-flex">
          <base-button
            design="four"
            class="mr_10 w-100"
            @click.prevent="prev"
            >{{
              $refs.uploadImage && $refs.uploadImage.current == 1
                ? 'Escolher outra'
                : 'Voltar'
            }}</base-button
          >
          <base-button
            :loading="uploadImageLoading"
            :disabled="btnCrop"
            class="w-100"
            @click.prevent="next"
            >{{
              $refs.uploadImage && $refs.uploadImage.current == 1
                ? 'Cortar'
                : 'Concluir'
            }}</base-button
          >
        </div>
      </template>
    </drawer>
  </div>
</template>

<script>
import { Cropper, ResizeEvent, CircleStencil } from 'vue-advanced-cropper';
import Drawer from '@/components/Drawer';
import BaseButton from '@/components/Button';
import BaseSteps from '@/components/Steps';
import BaseMessage from '@/components/Message';

const axios = require('axios');

export default {
  name: 'easy-upload-image',
  props: {
    label: {
      default: 'Escolher imagem',
    },
    ratio: {
      default: 1 / 1,
    },
    minWidth: {},
    minHeight: {},
    maxWidth: null,
    maxHeight: null,
    environment: {},
    circle: {
      default: false,
    },
  },
  created() {},
  data() {
    return {
      openDrawer: false,
      closeDrawer: false,
      img: '',
      btnCrop: false,
      errors: [],
      warnings: [],
      previewImage: '',
      uploadImageLoading: false,
      imageQuality: 1,
      imageType: '',
      maxUploadSize: 4096,
      minCropHeight: 10,
      minCropWidth: 10,
    };
  },
  components: {
    Drawer,
    Cropper,
    BaseButton,
    BaseSteps,
    CircleStencil,
    BaseMessage,
  },
  methods: {
    next() {
      this.uploadImageLoading = true;

      // setTimeout utilizado para renderizar primeiramente o uploadImageLoading e somente após a renderização, executar o método de preview
      // this.$nextTick não é uma opção, visto que executa antes da renderização e após a alteração do dado, bloqueando a visualização do loading no botão
      setTimeout(() => {
        if (this.$refs.uploadImage.current === this.$refs.uploadImage.steps) {
          this.finish();
        } else {
          this.preview();
          this.uploadImageLoading = false;
        }
        this.$refs.uploadImage.next();
      }, 0);
    },
    prev() {
      if (this.$refs.uploadImage.current === 1) {
        this.change();
      }
      this.$refs.uploadImage.prev();
    },

    finish() {
      this.crop();
    },

    checkLimits(data) {
      this.errors = [];
      this.warnings = [];
      let hasErrors = false;

      if (data.canvas && this.$refs.inputfile.files.length > 0) {
        const imgSrc = URL.createObjectURL(this.$refs.inputfile.files[0]);
        const checkImage = new Image();
        checkImage.src = imgSrc;
        checkImage.onload = () => {
          URL.revokeObjectURL(imgSrc);
          if (
            checkImage.width <= this.minWidth ||
            checkImage.height <= this.minHeight
          ) {
            this.warnings = [
              ...this.warnings,
              StringLanguage.imageCannotBeCropped,
            ];
            if (checkImage.width > checkImage.height) this.minCropHeight = 100;
            else this.minCropWidth = 100;
          }
        };
      }

      if (this.minWidth) {
        if (data.canvas && data.canvas.width < parseInt(this.minWidth)) {
          alert(`Largura mínima do corte é ${this.minWidth}px`);
          this.errors = [
            ...this.errors,
            `Largura mínima do corte é ${this.minWidth}px`,
          ];
          this.btnCrop = 'disabled';
          hasErrors = true;
        }
      }

      if (this.minHeight) {
        if (data.canvas && data.canvas.height < parseInt(this.minHeight)) {
          alert(`Altura mínima do corte é ${this.minHeight}px`);
          this.errors = [
            ...this.errors,
            `Altura mínima do corte é ${this.minHeight}px`,
          ];
          this.btnCrop = 'disabled';
          hasErrors = true;
        }
      }

      if (this.maxUploadSize) {
        if (
          data.canvas &&
          this.getBase64Size(data.canvas.toDataURL('image/jpeg', 1)) >
            this.maxUploadSize
        ) {
          this.warnings = [
            ...this.warnings,
            StringLanguage.imageQualityCanBeReduced,
          ];
        }
      }

      if (!hasErrors) {
        this.btnCrop = false;
      }
    },
    change() {
      this.$refs.inputfile.click();
    },
    confirmClose() {
      return (
        this.closeDrawer ||
        confirm(StringLanguage.confirmClose).then((r) => {
          if (r) {
            this.img = '';
            this.$refs.inputfile.value = '';
            this.$refs.uploadImage.current = 1;
            return true;
          }
          return false;
        })
      );
    },
    cropper() {
      this.minCropWidth = 10;
      this.minCropHeight = 10;
      if (this.$refs.inputfile.files.length) {
        const imgSrc = URL.createObjectURL(this.$refs.inputfile.files[0]);
        this.imageType = this.getNewFormat(this.$refs.inputfile.files[0].type);

        const checkImage = new Image();

        checkImage.onload = (event) => {
          let hasErrors = false;
          if (
            this.minWidth ? checkImage.width < parseInt(this.minWidth) : false
          ) {
            alert(`Largura mínima do corte é ${this.minWidth}px`);
            this.btnCrop = 'disabled';
            hasErrors = true;
          }

          if (
            !hasErrors && this.minHeight
              ? checkImage.height < parseInt(this.minHeight)
              : false
          ) {
            alert(`Altura mínima do corte é ${this.minHeight}px`);
            this.btnCrop = 'disabled';
            hasErrors = true;
          }

          if (!hasErrors) {
            let dataurl = imgSrc;

            // Se altura e largura máxima estiverem definidos, verifica-se se a imagem está dentro do limite
            if (this.maxWidth && this.maxHeight) {
              const img = event.currentTarget;

              const canvas = document.createElement('canvas');
              let ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);

              let { width } = img;
              let { height } = img;

              // Verifcação para reduzir a imagem proporcionalmente
              if (width > height) {
                if (width > this.maxWidth) {
                  height *= this.maxWidth / width;
                  width = this.maxWidth;
                }
              } else if (height > this.maxHeight) {
                width *= this.maxHeight / height;
                height = this.maxHeight;
              }

              // Definição tamanho do canvas no mesmo tamanho que a imagem já reduzida
              canvas.width = width;
              canvas.height = height;

              ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);

              this.imageType = this.getNewFormat(
                this.$refs.inputfile.files[0].type
              );

              dataurl = canvas.toDataURL(this.imageType, 1);
            }

            this.openDrawer = !this.openDrawer;
            this.btnCrop = false;
            this.img = dataurl;
          } else this.$refs.inputfile.value = '';
        };

        checkImage.src = imgSrc;
      }
    },

    getNewFormat(originalFormat) {
      const defaultFormat = 'image/jpeg';

      if (originalFormat === 'image/png') {
        return originalFormat;
      }

      return defaultFormat;
    },

    getBase64Size(base64Data) {
      return Buffer.byteLength(base64Data, 'utf8') / 1000; // Size in KB.
    },
    preview() {
      const { canvas } = this.$refs.cropperPreview.getResult();
      this.imageQuality = 1;

      do {
        this.previewImage = canvas.toDataURL(this.imageType, this.imageQuality);
        this.imageQuality -= 0.01;
      } while (
        this.getBase64Size(this.previewImage) > this.maxUploadSize &&
        this.imageQuality >= 0.1
      );
    },
    crop() {
      axios
        .post(
          process.env.VUE_APP_UPLOAD_IMAGES,
          {
            environment: this.environment,
            image: this.previewImage,
          },
          {
            onUploadProgress: () => {
              this.uploadImageLoading = true;
              this.closeDrawer = false;
            },
          }
        )
        .then((response) => {
          this.$emit('setImage', response.data.fileName);
          this.errors = [];
          this.warnings = [];
          this.$refs.inputfile.value = '';
          this.$refs.uploadImage.current = 1;
          this.uploadImageLoading = false;
          this.closeDrawer = true;
        });
    },
  },
};
</script>

<style>
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.circle {
  border-radius: 100%;
}
</style>
